
//******* Main User profile ********//

// import React, { useState, useEffect } from "react";
// import Navbar from "../../../Components/Navbar";
// import { jwtDecode } from "jwt-decode";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import userpic from "../../../Components/images/Usericon.png";
// import { URL } from "../../../config";
// import EditProfileForm from "./EditProfileForm";
// import OrderHistory from "./OrderHistory";
// import OrderDetailsView from "./OrderDetailsView";
// import { Star } from "lucide-react";
// import NotificationsPage from "../Notification/NotificationsPage";

// const UserProfile = () => {
//   const [activeSection, setActiveSection] = useState("Profile");
//   const [user, setUser] = useState(null);
//   const [isEditFormVisible, setEditFormVisible] = useState(false);
//   const [isFullScreen, setFullScreen] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

//   // States for changing password
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [warningMessage, setWarningMessage] = useState("");

//   // Order management
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, []);

//   const fetchUserDetails = async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(`${URL}/user/${extractedUserId}`);
//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       setUser(null);
//     }
//   };

//   const handleProfileUpdate = () => {
//     if (user) {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       fetchUserDetails(extractedUserId);
//     }
//   };

//   // Change Password
//   const handlePasswordChange = async (e) => {
//     e.preventDefault();
//     setPasswordError("");
//     setSuccessMessage("");
//     setWarningMessage("");

//     if (newPassword !== confirmPassword) {
//       setWarningMessage("New password and confirm password do not match.");
//       setNewPassword("");
//       setConfirmPassword("");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(
//         `${URL}/user/${extractedUserId}/change-password`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             currentPassword,
//             newPassword,
//           }),
//         }
//       );

//       if (response.ok) {
//         setSuccessMessage("Password changed successfully.");
//         setCurrentPassword("");
//         setNewPassword("");
//         setConfirmPassword("");
//       } else {
//         const errorData = await response.json();
//         setPasswordError(errorData.error);
//         setCurrentPassword("");
//         setNewPassword("");
//         setConfirmPassword("");
//       }
//     } catch (error) {
//       console.error("Error changing password:", error);
//       setPasswordError("Error changing password");
//     }
//   };

//   // Full screen image view
//   const handleImageClick = () => {
//     setFullScreen(true);
//   };

//   // Delete user image
//   const handleImageDelete = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(
//         `${URL}/user/${extractedUserId}/delete-image`,
//         {
//           method: "DELETE",
//         }
//       );

//       if (response.ok) {
//         setUser({ ...user, image: "" });
//       } else {
//         console.error("Error deleting image");
//       }
//     } catch (error) {
//       console.error("Error deleting image:", error);
//     }
//     setShowDeleteConfirm(false);
//     setFullScreen(false);
//   };

//   // Manage Order
//   const handleManageOrder = (order) => {
//     setSelectedOrder(order);
//     setActiveSection("orderDetailsView");
//   };

//   // Cancel details view
//   const handleCancelOrderDetails = () => {
//     setSelectedOrder(null);
//     setActiveSection("orderHistory");
//   };

//   // ----------- Inline Styles (Responsive with Flex Wrapping) -----------
//   const pageContainerStyle = {
//     width: "100%",
//     minHeight: "100vh",
//     backgroundColor: "#f5f5f5",
//     paddingTop: isFullScreen ? "0" : "60px",
//   };

//   const mainWrapperStyle = {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "20px",
//   };

//   // Profile Header (top bar) style
//   // flexWrap allows the image & user info to stack on smaller screens
//   const profileHeaderStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     display: "flex",
//     flexWrap: "wrap", // Allows wrapping on small screens
//     alignItems: "center",
//     padding: "20px",
//     marginBottom: "20px",
//     gap: "20px",
//   };

//   // On small screens, the image can center by auto margin if needed
//   const userImageStyle = {
//     width: "100px",
//     height: "100px",
//     borderRadius: "50%",
//     objectFit: "cover",
//     cursor: "pointer",
//     flexShrink: 0, // So it doesn't shrink too small
//   };

//   // Let user info fill the remaining space or wrap below the image
//   const userInfoStyle = {
//     display: "flex",
//     flexDirection: "column",
//     flexGrow: 1,
//     justifyContent: "center",
//     minWidth: "200px",
//   };

//   const userNameStyle = {
//     fontSize: "2rem",
//     fontWeight: "600",
//     margin: "0 0 5px 0",
//     color: "#333",
//     textAlign: "left",
//   };

//   const badgeContainerStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     flexWrap: "wrap",
//   };

//   // Tab Navigation style
//   // flexWrap helps the tabs wrap on small screens
//   const tabNavStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     padding: "10px 20px",
//     marginBottom: "20px",
//     gap: "20px",
//   };

//   const tabItemStyle = (isActive) => ({
//     fontSize: "1rem",
//     fontWeight: 500,
//     color: isActive ? "#4361ee" : "#555",
//     cursor: "pointer",
//     borderBottom: isActive ? "3px solid #4361ee" : "3px solid transparent",
//     paddingBottom: "8px",
//   });

//   // Content container style
//   const contentContainerStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     padding: "20px",
//     minHeight: "200px",
//   };

//   // Reusable "card" style for the form sections
//   const sectionCardStyle = {
//     backgroundColor: "#fff",
//     border: "1px solid #ddd",
//     borderRadius: "8px",
//     padding: "20px",
//     marginBottom: "20px",
//   };

//   const sectionHeaderStyle = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: "20px",
//   };

//   const sectionTitleStyle = {
//     fontSize: "20px",
//     fontWeight: "700",
//     color: "#333",
//     margin: 0,
//   };

//   const editButtonStyle = {
//     backgroundColor: "transparent",
//     border: "none",
//     color: "#2db94d",
//     fontSize: "1rem",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//   };

//   // Additional inline styles for form inputs & values
//   const valueBoxStyle = {
//     background: "rgba(0, 0, 0, 0.1)",
//     color: "#000",
//     border: "1px solid rgba(0, 0, 0, 0.5)",
//     borderRadius: "5px",
//     fontSize: "1rem",
//     padding: "0.75rem",
//     minHeight: "40px",
//     boxSizing: "border-box",
//   };

//   const inputStyle = {
//     width: "100%",
//     height: "50px",
//     padding: "0.75rem",
//     marginBottom: "1rem",
//     boxSizing: "border-box",
//     border: "1px solid rgba(0, 0, 0, 0.5)",
//     borderRadius: "5px",
//     fontSize: "1rem",
//     fontWeight: "400",
//     background: "rgba(0, 0, 0, 0.1)",
//     color: "#000",
//   };

//   const submitButtonStyle = {
//     padding: "12px",
//     backgroundColor: "#28a745",
//     color: "white",
//     border: "none",
//     borderRadius: "5px",
//     fontSize: "1rem",
//     cursor: "pointer",
//     marginTop: "10px",
//     display: "block",
//     width: "100%",
//     fontWeight: 600,
//   };

//   // *** Responsive row/column styles for the profile form ***
//   // "flexWrap: 'wrap'" ensures columns stack on narrow screens.
//   // Each column is "flex: '1 1 300px'" => it tries to be at least 300px wide
//   // but will wrap if there's not enough space.
//   const rowStyle = {
//     width: "100%",
//     display: "flex",
//     flexWrap: "wrap",
//     marginBottom: "20px",
//   };

//   const colStyle = {
//     flex: "1 1 300px",
//     marginRight: "20px",
//     marginBottom: "20px",
//     // We can ensure that the last column in a row doesn't get extra marginRight,
//     // but for simplicity, we'll keep it consistent. 
//   };

//   // Render different sections
//   const renderContent = () => {
//     switch (activeSection) {
//       case "Profile":
//         return (
//           <div style={sectionCardStyle}>
//             {user && (
//               <>
//                 {/* "Personal Information" header with Edit button */}
//                 <div style={sectionHeaderStyle}>
//                   <h2 style={sectionTitleStyle}>Personal Information</h2>
//                   <button
//                     style={editButtonStyle}
//                     onClick={() => setEditFormVisible(true)}
//                   >
//                     <i className="fas fa-edit" style={{ marginRight: "5px" }}></i>
//                     Edit
//                   </button>
//                 </div>

//                 {/* Profile Fields */}
//                 <form style={{ display: "flex", flexDirection: "column" }}>
//                   {/* Row 1 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         First name
//                       </div>
//                       <div style={valueBoxStyle}>{user.FirstName || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Last name
//                       </div>
//                       <div style={valueBoxStyle}>{user.LastName || ""}</div>
//                     </div>
//                   </div>

//                   {/* Row 2 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Email
//                       </div>
//                       <div style={valueBoxStyle}>{user.email || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Mobile
//                       </div>
//                       <div style={valueBoxStyle}>
//                         {user.mobile ? "0" + user.mobile : ""}
//                       </div>
//                     </div>
//                   </div>

//                   {/* Row 3 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         City
//                       </div>
//                       <div style={valueBoxStyle}>{user.city || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Gender
//                       </div>
//                       <div style={valueBoxStyle}>{user.gender || ""}</div>
//                     </div>
//                   </div>

//                   {/* Row 4 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Address
//                       </div>
//                       <div style={valueBoxStyle}>{user.Address || ""}</div>
//                     </div>
//                   </div>
//                 </form>
//               </>
//             )}
//           </div>
//         );
//       case "changePassword":
//         return (
//           <div style={sectionCardStyle}>
//             <div style={sectionHeaderStyle}>
//               <h2 style={sectionTitleStyle}>Change Password</h2>
//             </div>
//             <form
//               style={{ display: "flex", flexDirection: "column" }}
//               onSubmit={handlePasswordChange}
//             >
//               {passwordError && (
//                 <div style={{ color: "red", marginBottom: "10px" }}>
//                   {passwordError}
//                 </div>
//               )}
//               {successMessage && (
//                 <div style={{ color: "green", marginBottom: "10px" }}>
//                   {successMessage}
//                 </div>
//               )}
//               {warningMessage && (
//                 <div style={{ color: "orange", marginBottom: "10px" }}>
//                   {warningMessage}
//                 </div>
//               )}

//               {/* Current Password */}
//               <div style={{ marginBottom: "20px" }}>
//                 <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//                   Current Password
//                 </label>
//                 <input
//                   type="password"
//                   value={currentPassword}
//                   onChange={(e) => setCurrentPassword(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               {/* New Password */}
//               <div style={{ marginBottom: "20px" }}>
//                 <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//                   New Password
//                 </label>
//                 <input
//                   type="password"
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               {/* Confirm Password */}
//               <div style={{ marginBottom: "20px" }}>
//                 <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//                   Confirm Password
//                 </label>
//                 <input
//                   type="password"
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               <button type="submit" style={submitButtonStyle}>
//                 Change Password
//               </button>
//             </form>
//           </div>
//         );
//       case "orderHistory":
//         return <OrderHistory onManageClick={handleManageOrder} />;
//       case "orderDetailsView":
//         return (
//           <OrderDetailsView
//             order={selectedOrder}
//             onCancel={handleCancelOrderDetails}
//             onBack={() => setActiveSection("orderHistory")}
//           />
//         );

//       case "notifications":
//         return <NotificationsPage />;

//       default:
//         return null;
//     }
//   };

//   // Rendering the entire page
//   return (
//     <>
//       {!isFullScreen && <Navbar />}
//       <div style={pageContainerStyle}>
//         <div style={mainWrapperStyle}>
//           {/* TOP PROFILE HEADER */}
//           <div style={profileHeaderStyle}>
//             <img
//               src={user && user.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               style={userImageStyle}
//               onClick={handleImageClick}
//             />

//             <div style={userInfoStyle}>
//               <h3 style={userNameStyle}>
//                 {user ? `${user.FirstName} ${user.LastName}` : "User"}
//               </h3>

//               {/* Status + Rating + Points */}
//               {user && (
//                 <div style={badgeContainerStyle}>
//                   {/* STATUS PILL */}
//                   {user.status && (
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.25rem",
//                         padding: "4px 8px",
//                         borderRadius: "9999px",
//                         fontSize: "0.875rem",
//                         fontWeight: 500,
//                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                         backgroundColor:
//                           user.status === "Verified"
//                             ? "#D1FAE5"
//                             : user.status === "Pending"
//                             ? "#FEF3C7"
//                             : "#FEE2E2",
//                         color:
//                           user.status === "Verified"
//                             ? "#10B981"
//                             : user.status === "Pending"
//                             ? "#F59E0B"
//                             : "#EF4444",
//                       }}
//                     >
//                       {user.status === "Verified" && (
//                         <>
//                           <i
//                             className="bx bxs-check-shield"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Verified
//                         </>
//                       )}
//                       {user.status === "Pending" && (
//                         <>
//                           <i
//                             className="bx bxs-hourglass-bottom"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Pending
//                         </>
//                       )}
//                       {user.status === "Blocked" && (
//                         <>
//                           <i
//                             className="bx bxs-error-alt"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Blocked
//                         </>
//                       )}
//                     </div>
//                   )}

//                   {/* RATING PILL */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#FEF3C7",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <span style={{ fontWeight: "bold", color: "#F59E0B" }}>
//                       {user.rating ? user.rating.toFixed(1) : "0.0"}
//                     </span>
//                     <Star size={18} style={{ color: "#FBBF24", fill: "#FBBF24" }} />
//                   </div>

//                   {/* REWARD POINTS PILL */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#F0F9FF",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <i
//                       className="bx bxs-trophy"
//                       style={{
//                         fontSize: "15px",
//                         color: "#0284C7",
//                         marginBottom: "4px",
//                       }}
//                     ></i>
//                     <div style={{ fontSize: "15px", fontWeight: "bold", color: "#0284C7" }}>
//                       {user.rewardPoints || 0}
//                     </div>
//                     <div style={{ fontSize: "12px", color: "#0284C7", fontWeight: "600" }}>
//                       Reward Points
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* TAB NAVIGATION */}
//           <div style={tabNavStyle}>
//             <div
//               style={tabItemStyle(activeSection === "Profile")}
//               onClick={() => {
//                 setActiveSection("Profile");
//                 setSelectedOrder(null);
//               }}
//             >
//               Profile
//             </div>
//             <div
//               style={tabItemStyle(activeSection === "changePassword")}
//               onClick={() => {
//                 setActiveSection("changePassword");
//                 setSelectedOrder(null);
//               }}
//             >
//               Change Password
//             </div>
//             <div
//               style={tabItemStyle(activeSection === "orderHistory")}
//               onClick={() => {
//                 setActiveSection("orderHistory");
//                 setSelectedOrder(null);
//               }}
//             >
//               Order History
//             </div>

//             <div
//               style={tabItemStyle(activeSection === "notifications")}
//               onClick={() => {
//                 setActiveSection("notifications");
//                 setSelectedOrder(null);
//               }}
//             >
//               Notifications
//             </div>
//           </div>

//           {/* MAIN CONTENT AREA */}
//           <div style={contentContainerStyle}>{renderContent()}</div>
//         </div>
//       </div>

//       {/* Edit Profile Form (Modal) */}
//       {isEditFormVisible && (
//         <EditProfileForm
//           user={user}
//           onClose={() => setEditFormVisible(false)}
//           onProfileUpdate={handleProfileUpdate}
//         />
//       )}

//       {/* Full-Screen Image Modal */}
//       {isFullScreen && (
//         <div
//           className="full-screen-modal"
//           onClick={() => setFullScreen(false)}
//         >
//           <img
//             src={user && user.image ? `${URL}${user.image}` : userpic}
//             alt="User"
//             className="full-screen-image"
//           />
//           {user && user.image && (
//             <button
//               className="delete-button"
//               onClick={(e) => {
//                 e.stopPropagation(); // Prevent closing the modal
//                 setShowDeleteConfirm(true);
//               }}
//             >
//               Delete Image
//             </button>
//           )}
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="delete-confirm-modal">
//           <div className="delete-confirm-content">
//             <p>Are you sure you want to delete the image?</p>
//             <button onClick={handleImageDelete}>Yes</button>
//             <button onClick={() => setShowDeleteConfirm(false)}>No</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserProfile;




//***** update userprofile with url ******/



// import React, { useState, useEffect } from "react";
// import { Outlet, Link, useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import { jwtDecode } from "jwt-decode";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import userpic from "../../../Components/images/Usericon.png";
// import { URL } from "../../../config";
// import EditProfileForm from "./EditProfileForm";
// // import OrderHistory from "./OrderHistory";
// // import OrderDetailsView from "./OrderDetailsView";
// import { Star } from "lucide-react";
// // import NotificationsPage from "../Notification/NotificationsPage";

// const UserProfile = () => {
//   // const [activeSection, setActiveSection] = useState("Profile");
//   const [user, setUser] = useState(null);
//   const [isEditFormVisible, setEditFormVisible] = useState(false);
//   const [isFullScreen, setFullScreen] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const location = useLocation();

//   // States for changing password
//   // const [currentPassword, setCurrentPassword] = useState("");
//   // const [newPassword, setNewPassword] = useState("");
//   // const [confirmPassword, setConfirmPassword] = useState("");
//   // const [passwordError, setPasswordError] = useState("");
//   // const [successMessage, setSuccessMessage] = useState("");
//   // const [warningMessage, setWarningMessage] = useState("");

//   // Order management
//   // const [selectedOrder, setSelectedOrder] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, []);

//   const fetchUserDetails = async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(`${URL}/user/${extractedUserId}`);
//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       setUser(null);
//     }
//   };

//   const handleProfileUpdate = () => {
//     if (user) {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       fetchUserDetails(extractedUserId);
//     }
//   };

//   // // Change Password
//   // const handlePasswordChange = async (e) => {
//   //   e.preventDefault();
//   //   setPasswordError("");
//   //   setSuccessMessage("");
//   //   setWarningMessage("");

//   //   if (newPassword !== confirmPassword) {
//   //     setWarningMessage("New password and confirm password do not match.");
//   //     setNewPassword("");
//   //     setConfirmPassword("");
//   //     return;
//   //   }

//   //   try {
//   //     const token = localStorage.getItem("token");
//   //     const decodedToken = jwtDecode(token);
//   //     const userId = decodedToken.Id;
//   //     const extractedUserId = userId.startsWith("user-")
//   //       ? userId.split("user-")[1]
//   //       : userId;
//   //     const response = await fetch(
//   //       `${URL}/user/${extractedUserId}/change-password`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({
//   //           currentPassword,
//   //           newPassword,
//   //         }),
//   //       }
//   //     );

//   //     if (response.ok) {
//   //       setSuccessMessage("Password changed successfully.");
//   //       setCurrentPassword("");
//   //       setNewPassword("");
//   //       setConfirmPassword("");
//   //     } else {
//   //       const errorData = await response.json();
//   //       setPasswordError(errorData.error);
//   //       setCurrentPassword("");
//   //       setNewPassword("");
//   //       setConfirmPassword("");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error changing password:", error);
//   //     setPasswordError("Error changing password");
//   //   }
//   // };

//   // Full screen image view
//   const handleImageClick = () => {
//     setFullScreen(true);
//   };

//   // Delete user image
//   const handleImageDelete = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(
//         `${URL}/user/${extractedUserId}/delete-image`,
//         {
//           method: "DELETE",
//         }
//       );

//       if (response.ok) {
//         setUser({ ...user, image: "" });
//       } else {
//         console.error("Error deleting image");
//       }
//     } catch (error) {
//       console.error("Error deleting image:", error);
//     }
//     setShowDeleteConfirm(false);
//     setFullScreen(false);
//   };

//   // Manage Order remains unchanged
//   // const handleManageOrder = (order) => {
//   //   setSelectedOrder(order);
//   //   setActiveSection("orderDetailsView");
//   // };

//   // // Cancel details view remains unchanged
//   // const handleCancelOrderDetails = () => {
//   //   setSelectedOrder(null);
//   //   setActiveSection("orderHistory");
//   // };

//   // ----------- Inline Styles (Responsive with Flex Wrapping) -----------
//   const pageContainerStyle = {
//     width: "100%",
//     minHeight: "100vh",
//     backgroundColor: "#f5f5f5",
//     paddingTop: isFullScreen ? "0" : "60px",
//   };

//   const mainWrapperStyle = {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "20px",
//   };

//   const profileHeaderStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     padding: "20px",
//     marginBottom: "20px",
//     gap: "20px",
//   };

//   const userImageStyle = {
//     width: "100px",
//     height: "100px",
//     borderRadius: "50%",
//     objectFit: "cover",
//     cursor: "pointer",
//     flexShrink: 0,
//   };

//   const userInfoStyle = {
//     display: "flex",
//     flexDirection: "column",
//     flexGrow: 1,
//     justifyContent: "center",
//     minWidth: "200px",
//   };

//   const userNameStyle = {
//     fontSize: "2rem",
//     fontWeight: "600",
//     margin: "0 0 5px 0",
//     color: "#333",
//     textAlign: "left",
//   };

//   const badgeContainerStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     flexWrap: "wrap",
//   };

//   const tabNavStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     padding: "10px 20px",
//     marginBottom: "20px",
//     gap: "20px",
//   };

//   // **CHANGE HERE:** For Order History and Notifications, use Link components with proper URL paths.
//   const tabItemStyle = (isActive) => ({
//     fontSize: "1rem",
//     fontWeight: 500,
//     color: isActive ? "#4361ee" : "#555",
//     textDecoration: "none",
//     cursor: "pointer",
//     borderBottom: isActive ? "3px solid #4361ee" : "3px solid transparent",
//     paddingBottom: "8px",
//   });

//   const contentContainerStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     padding: "20px",
//     minHeight: "200px",
//   };

//   const sectionCardStyle = {
//     backgroundColor: "#fff",
//     border: "1px solid #ddd",
//     borderRadius: "8px",
//     padding: "20px",
//     marginBottom: "20px",
//   };

//   const sectionHeaderStyle = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: "20px",
//   };

//   const sectionTitleStyle = {
//     fontSize: "20px",
//     fontWeight: "700",
//     color: "#333",
//     margin: 0,
//   };

//   const editButtonStyle = {
//     backgroundColor: "transparent",
//     border: "none",
//     color: "#2db94d",
//     fontSize: "1rem",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//   };

//   const valueBoxStyle = {
//     background: "rgba(0, 0, 0, 0.1)",
//     color: "#000",
//     border: "1px solid rgba(0, 0, 0, 0.5)",
//     borderRadius: "5px",
//     fontSize: "1rem",
//     padding: "0.75rem",
//     minHeight: "40px",
//     boxSizing: "border-box",
//   };

//   // const inputStyle = {
//   //   width: "100%",
//   //   height: "50px",
//   //   padding: "0.75rem",
//   //   marginBottom: "1rem",
//   //   boxSizing: "border-box",
//   //   border: "1px solid rgba(0, 0, 0, 0.5)",
//   //   borderRadius: "5px",
//   //   fontSize: "1rem",
//   //   fontWeight: "400",
//   //   background: "rgba(0, 0, 0, 0.1)",
//   //   color: "#000",
//   // };

//   // const submitButtonStyle = {
//   //   padding: "12px",
//   //   backgroundColor: "#28a745",
//   //   color: "white",
//   //   border: "none",
//   //   borderRadius: "5px",
//   //   fontSize: "1rem",
//   //   cursor: "pointer",
//   //   marginTop: "10px",
//   //   display: "block",
//   //   width: "100%",
//   //   fontWeight: 600,
//   // };

//   const rowStyle = {
//     width: "100%",
//     display: "flex",
//     flexWrap: "wrap",
//     marginBottom: "20px",
//   };

//   const colStyle = {
//     flex: "1 1 300px",
//     marginRight: "20px",
//     marginBottom: "20px",
//   };

//   // **CHANGE HERE:** Instead of using activeSection state for orderHistory and notifications,
//   // check the current URL. If it starts with "/profile/orderhistory" or "/profile/notifications",
//   // render the nested route via <Outlet />.
//   const renderContent = () => {
//     if (
//       location.pathname.startsWith("/profile/orderhistory") ||
//       location.pathname.startsWith("/profile/notifications") ||
//       location.pathname.startsWith("/profile/changePassword")
//     ) {
//       return <Outlet />;
//     }
//     // Otherwise, render state-based content for Profile and Change Password.
//     // switch (activeSection) {
//     //   case "Profile":
//         return (
//           <div style={sectionCardStyle}>
//             {user && (
//               <>
//                 <div style={sectionHeaderStyle}>
//                   <h2 style={sectionTitleStyle}>Personal Information</h2>
//                   <button
//                     style={editButtonStyle}
//                     onClick={() => setEditFormVisible(true)}
//                   >
//                     <i className="fas fa-edit" style={{ marginRight: "5px" }}></i>
//                     Edit
//                   </button>
//                 </div>
//                 {/* Profile Fields */}
//                 <form style={{ display: "flex", flexDirection: "column" }}>
//                   {/* Row 1 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         First name
//                       </div>
//                       <div style={valueBoxStyle}>{user.FirstName || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Last name
//                       </div>
//                       <div style={valueBoxStyle}>{user.LastName || ""}</div>
//                     </div>
//                   </div>

//                   {/* Row 2 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Email
//                       </div>
//                       <div style={valueBoxStyle}>{user.email || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Mobile
//                       </div>
//                       <div style={valueBoxStyle}>
//                         {user.mobile ? "0" + user.mobile : ""}
//                       </div>
//                     </div>
//                   </div>

//                   {/* Row 3 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         City
//                       </div>
//                       <div style={valueBoxStyle}>{user.city || ""}</div>
//                     </div>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Gender
//                       </div>
//                       <div style={valueBoxStyle}>{user.gender || ""}</div>
//                     </div>
//                   </div>

//                   {/* Row 4 */}
//                   <div style={rowStyle}>
//                     <div style={colStyle}>
//                       <div style={{ fontWeight: "600", marginBottom: "5px" }}>
//                         Address
//                       </div>
//                       <div style={valueBoxStyle}>{user.Address || ""}</div>
//                     </div>
//                   </div>
//                 </form>
//               </>
//             )}
//           </div>
//         );
//       // case "changePassword":
//       //   return (
//       //     <div style={sectionCardStyle}>
//       //       <div style={sectionHeaderStyle}>
//       //         <h2 style={sectionTitleStyle}>Change Password</h2>
//       //       </div>
//       //       <form
//       //         style={{ display: "flex", flexDirection: "column" }}
//       //         onSubmit={handlePasswordChange}
//       //       >
//       //         {passwordError && (
//       //           <div style={{ color: "red", marginBottom: "10px" }}>
//       //             {passwordError}
//       //           </div>
//       //         )}
//       //         {successMessage && (
//       //           <div style={{ color: "green", marginBottom: "10px" }}>
//       //             {successMessage}
//       //           </div>
//       //         )}
//       //         {warningMessage && (
//       //           <div style={{ color: "orange", marginBottom: "10px" }}>
//       //             {warningMessage}
//       //           </div>
//       //         )}

//       //         {/* Current Password */}
//       //         <div style={{ marginBottom: "20px" }}>
//       //           <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//       //             Current Password
//       //           </label>
//       //           <input
//       //             type="password"
//       //             value={currentPassword}
//       //             onChange={(e) => setCurrentPassword(e.target.value)}
//       //             style={inputStyle}
//       //           />
//       //         </div>

//       //         {/* New Password */}
//       //         <div style={{ marginBottom: "20px" }}>
//       //           <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//       //             New Password
//       //           </label>
//       //           <input
//       //             type="password"
//       //             value={newPassword}
//       //             onChange={(e) => setNewPassword(e.target.value)}
//       //             style={inputStyle}
//       //           />
//       //         </div>

//       //         {/* Confirm Password */}
//       //         <div style={{ marginBottom: "20px" }}>
//       //           <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
//       //             Confirm Password
//       //           </label>
//       //           <input
//       //             type="password"
//       //             value={confirmPassword}
//       //             onChange={(e) => setConfirmPassword(e.target.value)}
//       //             style={inputStyle}
//       //           />
//       //         </div>

//       //         <button type="submit" style={submitButtonStyle}>
//       //           Change Password
//       //         </button>
//       //       </form>
//       //     </div>
//       //   );
//     //   default:
//     //     return null;
//     // }
//   };

//   return (
//     <>
//       {!isFullScreen && <Navbar />}
//       <div style={pageContainerStyle}>
//         <div style={mainWrapperStyle}>
//           {/* TOP PROFILE HEADER */}
//           <div style={profileHeaderStyle}>
//             <img
//               src={user && user.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               style={userImageStyle}
//               onClick={handleImageClick}
//             />
//             <div style={userInfoStyle}>
//               <h3 style={userNameStyle}>
//                 {user ? `${user.FirstName} ${user.LastName}` : "User"}
//               </h3>
//               {user && (
//                 <div style={badgeContainerStyle}>
//                   {user.status && (
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.25rem",
//                         padding: "4px 8px",
//                         borderRadius: "9999px",
//                         fontSize: "0.875rem",
//                         fontWeight: 500,
//                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                         backgroundColor:
//                           user.status === "Verified"
//                             ? "#D1FAE5"
//                             : user.status === "Pending"
//                             ? "#FEF3C7"
//                             : "#FEE2E2",
//                         color:
//                           user.status === "Verified"
//                             ? "#10B981"
//                             : user.status === "Pending"
//                             ? "#F59E0B"
//                             : "#EF4444",
//                       }}
//                     >
//                       {user.status === "Verified" && (
//                         <>
//                           <i
//                             className="bx bxs-check-shield"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Verified
//                         </>
//                       )}
//                       {user.status === "Pending" && (
//                         <>
//                           <i
//                             className="bx bxs-hourglass-bottom"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Pending
//                         </>
//                       )}
//                       {user.status === "Blocked" && (
//                         <>
//                           <i
//                             className="bx bxs-error-alt"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Blocked
//                         </>
//                       )}
//                     </div>
//                   )}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#FEF3C7",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <span style={{ fontWeight: "bold", color: "#F59E0B" }}>
//                       {user.rating ? user.rating.toFixed(1) : "0.0"}
//                     </span>
//                     <Star
//                       size={18}
//                       style={{ color: "#FBBF24", fill: "#FBBF24" }}
//                     />
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#F0F9FF",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <i
//                       className="bx bxs-trophy"
//                       style={{
//                         fontSize: "15px",
//                         color: "#0284C7",
//                         marginBottom: "4px",
//                       }}
//                     ></i>
//                     <div
//                       style={{
//                         fontSize: "15px",
//                         fontWeight: "bold",
//                         color: "#0284C7",
//                       }}
//                     >
//                       {user.rewardPoints || 0}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: "12px",
//                         color: "#0284C7",
//                         fontWeight: "600",
//                       }}
//                     >
//                       Reward Points
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* TAB NAVIGATION */}
//           <div style={tabNavStyle}>
//             <Link
//               to="/profile"
//               style={tabItemStyle(
//                 location.pathname === "/profile" ||
//                   location.pathname === "/profile/"
//               )}
//             >
//               Profile
//             </Link>
//             <Link
//               to="/profile/changePassword" // NEW: Link for Change Password
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/changePassword")
//               )}
//             >
//               Change Password
//             </Link>
//             {/* **CHANGE HERE:** Replace Order History and Notifications tabs with Link components */}
//             <Link
//               to="/profile/orderhistory"
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/orderhistory")
//               )}
//             >
//               Order History
//             </Link>
//             <Link
//               to="/profile/notifications"
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/notifications")
//               )}
//             >
//               Notifications
//             </Link>
//           </div>

//           {/* MAIN CONTENT AREA */}
//           <div style={contentContainerStyle}>{renderContent()}</div>
//         </div>
//       </div>

//       {/* Edit Profile Form (Modal) */}
//       {isEditFormVisible && (
//         <EditProfileForm
//           user={user}
//           onClose={() => setEditFormVisible(false)}
//           onProfileUpdate={handleProfileUpdate}
//         />
//       )}

//       {/* Full-Screen Image Modal */}
//       {isFullScreen && (
//         <div className="full-screen-modal" onClick={() => setFullScreen(false)}>
//           <img
//             src={user && user.image ? `${URL}${user.image}` : userpic}
//             alt="User"
//             className="full-screen-image"
//           />
//           {user && user.image && (
//             <button
//               className="delete-button"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setShowDeleteConfirm(true);
//               }}
//             >
//               Delete Image
//             </button>
//           )}
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="delete-confirm-modal">
//           <div className="delete-confirm-content">
//             <p>Are you sure you want to delete the image?</p>
//             <button onClick={handleImageDelete}>Yes</button>
//             <button onClick={() => setShowDeleteConfirm(false)}>No</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserProfile;









//************ Responsive and Update design All is okay checked (23-6-25) **************//

// import React, { useState, useEffect } from "react";
// import { Outlet, Link, useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import { jwtDecode } from "jwt-decode";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import userpic from "../../../Components/images/Usericon.png";
// import { URL } from "../../../config";
// import EditProfileForm from "./EditProfileForm";
// // import OrderHistory from "./OrderHistory";
// // import OrderDetailsView from "./OrderDetailsView";
// import { Star } from "lucide-react";
// // import NotificationsPage from "../Notification/NotificationsPage";
// // import "./userprofile.css";
// import "./userProfileStyle.css";

// const UserProfile = () => {
//   // const [activeSection, setActiveSection] = useState("Profile");
//   const [user, setUser] = useState(null);
//   const [isEditFormVisible, setEditFormVisible] = useState(false);
//   const [isFullScreen, setFullScreen] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const location = useLocation();


//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, []);

//   const fetchUserDetails = async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(`${URL}/user/${extractedUserId}`);
//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       setUser(null);
//     }
//   };

//   const handleProfileUpdate = () => {
//     if (user) {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       fetchUserDetails(extractedUserId);
//     }
//   };



//   // Full screen image view
//   const handleImageClick = () => {
//     setFullScreen(true);
//   };

//   // Delete user image
//   const handleImageDelete = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;
//       const response = await fetch(
//         `${URL}/user/${extractedUserId}/delete-image`,
//         {
//           method: "DELETE",
//         }
//       );

//       if (response.ok) {
//         setUser({ ...user, image: "" });
//       } else {
//         console.error("Error deleting image");
//       }
//     } catch (error) {
//       console.error("Error deleting image:", error);
//     }
//     setShowDeleteConfirm(false);
//     setFullScreen(false);
//   };


//   // ----------- Inline Styles (Responsive with Flex Wrapping) -----------
//   // const pageContainerStyle = {
//   //   width: "100%",
//   //   minHeight: "100vh",
//   //   backgroundColor: "#f5f5f5",
//   //   paddingTop: isFullScreen ? "0" : "60px",
//   // };

//   // const mainWrapperStyle = {
//   //   maxWidth: "1200px",
//   //   margin: "0 auto",
//   //   padding: "20px",
//   // };

//   // const profileHeaderStyle = {
//   //   backgroundColor: "#fff",
//   //   borderRadius: "8px",
//   //   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//   //   display: "flex",
//   //   flexWrap: "wrap",
//   //   alignItems: "center",
//   //   padding: "20px",
//   //   marginBottom: "20px",
//   //   gap: "20px",
//   // };

//   // const userImageStyle = {
//   //   width: "100px",
//   //   height: "100px",
//   //   borderRadius: "50%",
//   //   objectFit: "cover",
//   //   cursor: "pointer",
//   //   flexShrink: 0,
//   // };

//   // const userInfoStyle = {
//   //   display: "flex",
//   //   flexDirection: "column",
//   //   flexGrow: 1,
//   //   justifyContent: "center",
//   //   minWidth: "200px",
//   // };

//   // const userNameStyle = {
//   //   fontSize: "2rem",
//   //   fontWeight: "600",
//   //   margin: "0 0 5px 0",
//   //   color: "#333",
//   //   textAlign: "left",
//   // };

//   // const badgeContainerStyle = {
//   //   display: "flex",
//   //   alignItems: "center",
//   //   gap: "10px",
//   //   flexWrap: "wrap",
//   // };

//   // const tabNavStyle = {
//   //   backgroundColor: "#fff",
//   //   borderRadius: "8px",
//   //   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//   //   display: "flex",
//   //   flexWrap: "wrap",
//   //   alignItems: "center",
//   //   justifyContent: "flex-start",
//   //   padding: "10px 20px",
//   //   marginBottom: "20px",
//   //   gap: "20px",
//   // };

//   // **CHANGE HERE:** For Order History and Notifications, use Link components with proper URL paths.
//   const tabItemStyle = (isActive) => ({
//     fontSize: "1rem",
//     fontWeight: 500,
//     color: isActive ? "#4361ee" : "#555",
//     textDecoration: "none",
//     cursor: "pointer",
//     borderBottom: isActive ? "3px solid #4361ee" : "3px solid transparent",
//     paddingBottom: "8px",
//   });

//   const contentContainerStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//     padding: "20px",
//     minHeight: "200px",
//   };

//   // const sectionCardStyle = {
//   //   backgroundColor: "#fff",
//   //   border: "1px solid #ddd",
//   //   borderRadius: "8px",
//   //   padding: "20px",
//   //   marginBottom: "20px",
//   // };

//   // const sectionHeaderStyle = {
//   //   display: "flex",
//   //   alignItems: "center",
//   //   justifyContent: "space-between",
//   //   marginBottom: "20px",
//   // };

//   // const sectionTitleStyle = {
//   //   fontSize: "20px",
//   //   fontWeight: "700",
//   //   color: "#333",
//   //   margin: 0,
//   // };

//   // const editButtonStyle = {
//   //   backgroundColor: "transparent",
//   //   border: "none",
//   //   color: "#2db94d",
//   //   fontSize: "1rem",
//   //   cursor: "pointer",
//   //   display: "flex",
//   //   alignItems: "center",
//   // };

//   // const valueBoxStyle = {
//   //   background: "rgba(0, 0, 0, 0.1)",
//   //   color: "#000",
//   //   border: "1px solid rgba(0, 0, 0, 0.5)",
//   //   borderRadius: "5px",
//   //   // fontSize: "1rem",
//   //   fontSize: "0.85rem",
//   //   padding: "0.75rem",
//   //   minHeight: "40px",
//   //   boxSizing: "border-box",
//   // };



//   // const rowStyle = {
//   //   width: "100%",
//   //   display: "flex",
//   //   flexWrap: "wrap",
//   //   marginBottom: "20px",
//   // };

//   // const colStyle = {
//   //   flex: "1 1 300px",
//   //   marginRight: "20px",
//   //   marginBottom: "20px",
//   // };

//   // **CHANGE HERE:** Instead of using activeSection state for orderHistory and notifications,
//   // check the current URL. If it starts with "/profile/orderhistory" or "/profile/notifications",
//   // render the nested route via <Outlet />.
//   const renderContent = () => {
//     if (
//       location.pathname.startsWith("/profile/orderhistory") ||
//       location.pathname.startsWith("/profile/notifications") ||
//       location.pathname.startsWith("/profile/changePassword")
//     ) {
//       return <Outlet />;
//     }
//     // Otherwise, render state-based content for Profile and Change Password.
//     // switch (activeSection) {
//     //   case "Profile":
//     return (
//       <div className="section-card">
//         {user && (
//           <>
//             <div className="section-header">
//               <h2 className="section-title">Personal Information</h2>
//               <button
//                 className="UserProfile-edit-button"
//                 onClick={() => setEditFormVisible(true)}
//               >
//                 <i className="fas fa-edit" style={{ marginRight: "5px" }}></i>
//                 Edit
//               </button>
//             </div>
//             {/* Profile Fields */}
//             <form className="profile-fields-form">
//               {/* Row 1 */}
//               <div className="profile-row">
//                 <div className="profile-col">
//                   <div className="profile-field-label">First name</div>
//                   <div className="value-box">{user.FirstName || ""}</div>
//                 </div>
//                 <div className="profile-col">
//                   <div className="profile-field-label">Last name</div>
//                   <div className="value-box">{user.LastName || ""}</div>
//                 </div>
//               </div>

//               {/* Row 2 */}
//               <div className="profile-row">
//                 <div className="profile-col">
//                   <div className="profile-field-label">Email</div>
//                   <div className="value-box">{user.email || ""}</div>
//                 </div>
//                 <div className="profile-col">
//                   <div className="profile-field-label">Mobile</div>
//                   <div className="value-box">
//                     {user.mobile ? "0" + user.mobile : ""}
//                   </div>
//                 </div>
//               </div>

//               {/* Row 3 */}
//               <div className="profile-row">
//                 <div className="profile-col">
//                   <div className="profile-field-label">City</div>
//                   <div className="value-box">{user.city || ""}</div>
//                 </div>
//                 <div className="profile-col">
//                   <div className="profile-field-label">Gender</div>
//                   <div className="value-box">{user.gender || ""}</div>
//                 </div>
//               </div>

//               {/* Row 4 */}
//               <div className="profile-row">
//                 <div className="profile-col">
//                   <div className="profile-field-label">Address</div>
//                   <div className="value-box">{user.Address || ""}</div>
//                 </div>
//               </div>
//             </form>
//           </>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       {!isFullScreen && <Navbar />}
//       <div className="page-container">
//         <div className="main-wrapper">
//           {/* TOP PROFILE HEADER */}
//           <div className="profile-header">
//             <img
//               src={user && user.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               className="user-image"
//               onClick={handleImageClick}
//             />
//             <div className="user-info">
//               <h3 className="user-name">
//                 {user ? `${user.FirstName} ${user.LastName}` : "User"}
//               </h3>
//               {user && (
//                 <div className="badge-container">
//                   {user.status && (
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.25rem",
//                         padding: "4px 8px",
//                         borderRadius: "9999px",
//                         fontSize: "0.875rem",
//                         fontWeight: 500,
//                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                         backgroundColor:
//                           user.status === "Verified"
//                             ? "#D1FAE5"
//                             : user.status === "Pending"
//                             ? "#FEF3C7"
//                             : "#FEE2E2",
//                         color:
//                           user.status === "Verified"
//                             ? "#10B981"
//                             : user.status === "Pending"
//                             ? "#F59E0B"
//                             : "#EF4444",
//                       }}
//                     >
//                       {user.status === "Verified" && (
//                         <>
//                           <i
//                             className="bx bxs-check-shield"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Verified
//                         </>
//                       )}
//                       {user.status === "Pending" && (
//                         <>
//                           <i
//                             className="bx bxs-hourglass-bottom"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Pending
//                         </>
//                       )}
//                       {user.status === "Blocked" && (
//                         <>
//                           <i
//                             className="bx bxs-error-alt"
//                             style={{ fontSize: "1rem" }}
//                           ></i>
//                           Blocked
//                         </>
//                       )}
//                     </div>
//                   )}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#FEF3C7",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <span style={{ fontWeight: "bold", color: "#F59E0B" }}>
//                       {user.rating ? user.rating.toFixed(1) : "0.0"}
//                     </span>
//                     <Star
//                       size={18}
//                       style={{ color: "#FBBF24", fill: "#FBBF24" }}
//                     />
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.4rem",
//                       backgroundColor: "#F0F9FF",
//                       borderRadius: "9999px",
//                       padding: "4px 10px",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//                     }}
//                   >
//                     <i
//                       className="bx bxs-trophy"
//                       style={{
//                         fontSize: "15px",
//                         color: "#0284C7",
//                         marginBottom: "4px",
//                       }}
//                     ></i>
//                     <div
//                       style={{
//                         fontSize: "15px",
//                         fontWeight: "bold",
//                         color: "#0284C7",
//                       }}
//                     >
//                       {user.rewardPoints || 0}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: "12px",
//                         color: "#0284C7",
//                         fontWeight: "600",
//                       }}
//                     >
//                       Reward Points
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* TAB NAVIGATION */}
//           <div className="tab-nav">
//             <Link
//               to="/profile"
//               style={tabItemStyle(
//                 location.pathname === "/profile" ||
//                   location.pathname === "/profile/"
//               )}
//             >
//               Profile
//             </Link>
//             <Link
//               to="/profile/changePassword"
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/changePassword")
//               )}
//             >
//               {/* Change Password */}
//               Password
//             </Link>
//             {/* **CHANGE HERE:** Replace Order History and Notifications tabs with Link components */}
//             <Link
//               to="/profile/orderhistory"
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/orderhistory")
//               )}
//             >
//               {/* Order History */}
//               Orders
//             </Link>
//             <Link
//               to="/profile/notifications"
//               style={tabItemStyle(
//                 location.pathname.startsWith("/profile/notifications")
//               )}
//             >
//               Notifications
//             </Link>
//           </div>

//           {/* MAIN CONTENT AREA */}
//           <div style={contentContainerStyle}>{renderContent()}</div>
//           {/* <div className="content-container">{renderContent()}</div> */}
//         </div>
//       </div>

//       {/* Edit Profile Form (Modal) */}
//       {isEditFormVisible && (
//         <EditProfileForm
//           user={user}
//           onClose={() => setEditFormVisible(false)}
//           onProfileUpdate={handleProfileUpdate}
//         />
//       )}

//       {/* Full-Screen Image Modal */}
//       {isFullScreen && (
//         <div className="full-screen-modal" onClick={() => setFullScreen(false)}>
//           <img
//             src={user && user.image ? `${URL}${user.image}` : userpic}
//             alt="User"
//             className="full-screen-image"
//           />
//           {user && user.image && (
//             <button
//               className="delete-button"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setShowDeleteConfirm(true);
//               }}
//             >
//               Delete Image
//             </button>
//           )}
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="delete-confirm-modal">
//           <div className="delete-confirm-content">
//             <p>Are you sure you want to delete the image?</p>
//             <button onClick={handleImageDelete}>Yes</button>
//             <button onClick={() => setShowDeleteConfirm(false)}>No</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserProfile;

// ***** Upper code is okay checked userprofile (23-6-25) ***** //










// ***** Translate EN BN and updated (23-6-25) ***** //


import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import { jwtDecode } from "jwt-decode";
import "@fortawesome/fontawesome-free/css/all.min.css";
import userpic from "../../../Components/images/Usericon.png";
import { URL } from "../../../config";
import EditProfileForm from "./EditProfileForm";
import { Star } from "lucide-react";
import "./userProfileStyle.css";
import { useTranslation } from "react-i18next";
import Loader from "../../../Components/LoaderSpin/Loader";
import SEO from "../../../Components/SEO/SEO";

const UserProfile = () => {
  // const [activeSection, setActiveSection] = useState("Profile");
  const { t } = useTranslation();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditFormVisible, setEditFormVisible] = useState(false);
  const [isFullScreen, setFullScreen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      fetchUserDetails(decodedToken.Id);
    }
  }, []);

  const fetchUserDetails = async (userId) => {
    setLoading(true);
    try {
      const extractedUserId = userId.startsWith("user-")
        ? userId.split("user-")[1]
        : userId;
      const response = await fetch(`${URL}/user/${extractedUserId}`);
      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleProfileUpdate = () => {
    if (user) {
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.Id;
      const extractedUserId = userId.startsWith("user-")
        ? userId.split("user-")[1]
        : userId;
      fetchUserDetails(extractedUserId);
    }
  };



  // Full screen image view
  const handleImageClick = () => {
    setFullScreen(true);
  };

  // Delete user image
  const handleImageDelete = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.Id;
      const extractedUserId = userId.startsWith("user-")
        ? userId.split("user-")[1]
        : userId;
      const response = await fetch(
        `${URL}/user/${extractedUserId}/delete-image`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setUser({ ...user, image: "" });
      } else {
        console.error("Error deleting image");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    } finally {
      setLoading(false);
    }
    setShowDeleteConfirm(false);
    setFullScreen(false);
  };


  useEffect(() => {
    if (isFullScreen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    // Cleanup on unmount or state change
    return () => document.body.classList.remove("no-scroll");
  }, [isFullScreen]);


  // **CHANGE HERE:** For Order History and Notifications, use Link components with proper URL paths.
  const tabItemStyle = (isActive) => ({
    fontSize: "1rem",
    fontWeight: 500,
    color: isActive ? "#4361ee" : "#555",
    textDecoration: "none",
    cursor: "pointer",
    borderBottom: isActive ? "3px solid #4361ee" : "3px solid transparent",
    paddingBottom: "8px",
  });

  const contentContainerStyle = {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    padding: "20px",
    minHeight: "200px",
  };
  // **CHANGE HERE:** Instead of using activeSection state for orderHistory and notifications,
  // check the current URL. If it starts with "/profile/orderhistory" or "/profile/notifications",
  // render the nested route via <Outlet />.
  const renderContent = () => {
    if (
      location.pathname.startsWith("/profile/orderhistory") ||
      location.pathname.startsWith("/profile/notifications") ||
      location.pathname.startsWith("/profile/changePassword") ||
      location.pathname.startsWith("/profile/rewards") ||
      location.pathname.startsWith("/profile/support")
    ) {
      return <Outlet />;
    }
    // Otherwise, render state-based content for Profile and Change Password.
    // switch (activeSection) {
    //   case "Profile":
    return (
      <div className="section-card">
        {user && (
          <>
            <div className="section-header">
              {/* <h2 className="section-title">Personal Information</h2> */}
              <h2 className="section-title">{t('userProfile.personalInformation')}</h2>
              <button
                className="UserProfile-edit-button"
                onClick={() => setEditFormVisible(true)}
              >
                <i className="fas fa-edit" style={{ marginRight: "5px" }}></i>
                {/* Edit */}
                {t('userProfile.edit')}
              </button>
            </div>
            {/* Profile Fields */}
            <form className="profile-fields-form">
              {/* Row 1 */}
              <div className="profile-row">
                <div className="profile-col">
                  {/* <div className="profile-field-label">First name</div> */}
                  <div className="profile-field-label">{t('userProfile.firstName')}</div>
                  <div className="value-box">{user.FirstName || ""}</div>
                </div>
                <div className="profile-col">
                  {/* <div className="profile-field-label">Last name</div> */}
                  <div className="profile-field-label">{t('userProfile.lastName')}</div>
                  <div className="value-box">{user.LastName || ""}</div>
                </div>
              </div>

              <div className="profile-row">
                <div className="profile-col">
                  <div className="profile-field-label">{t("userProfile.mobile")}</div>
                  <div className="value-box">{user.mobile || ""}</div>
                </div>

                <div className="profile-col">
                  {/* <div className="profile-field-label">City</div> */}
                  <div className="profile-field-label">{t('userProfile.city')}</div>
                  <div className="value-box">{user.city || ""}</div>
                </div>
              </div>

              {/* Row 2 */}
              {/* <div className="profile-row">
                <div className="profile-col">
                <div className="profile-field-label">{t('userProfile.email')}</div>
                  <div className="value-box">{user.email || ""}</div>
                </div>
                <div className="profile-col">
                <div className="profile-field-label">{t('userProfile.mobile')}</div>
                  <div className="value-box">
                    {user.mobile || ""}
                  </div>
                </div>
              </div> */}

              {/* Row 3 */}
              <div className="profile-row">

                <div className="profile-col">
                  {/* <div className="profile-field-label">Gender</div> */}
                  <div className="profile-field-label">{t('userProfile.area')}</div>
                  {/* <div className="value-box">{user.gender || ""}</div> */}
                  <div className="value-box">{user.area || ""}</div>
                </div>

                <div className="profile-col">
                  {/* <div className="profile-field-label">Address</div> */}
                  <div className="profile-field-label">{t('userProfile.address')}</div>
                  <div className="value-box">{user.Address || ""}</div>
                </div>
              </div>
            </form>

            {/* Add change password button */}

            <div className="section-bottom-buttons">
              <button
                className="UserProfile-password-button"
                onClick={() => navigate("/profile/changePassword")}
              >
                <i className="fas fa-lock" style={{ marginRight: "8px" }}></i>
                {t('userProfile.changePassword')} {/* Assuming translation key; adjust if needed */}
                <i className="fas fa-arrow-right" style={{ marginLeft: "8px" }}></i>
              </button>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <SEO title="User Profile | HelpNao" path="/profile" noindex />

      <Loader show={loading} />

      {!isFullScreen && <Navbar />}
      <div className="page-container">
        <div className="main-wrapper">
          {/* TOP PROFILE HEADER */}
          <div className="profile-header">
            <img
              src={user && user.image ? `${URL}${user.image}` : userpic}
              alt="User"
              className="user-image"
              onClick={handleImageClick}
            />
            <div className="user-info">
              <h3 className="user-name">
                {user ? `${user.FirstName} ${user.LastName}` : "User"}
              </h3>
              {user && (
                <div className="badge-container">
                  {user.status && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        padding: "4px 8px",
                        borderRadius: "9999px",
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          user.status === "Verified"
                            ? "#D1FAE5"
                            : user.status === "Pending"
                              ? "#FEF3C7"
                              : "#FEE2E2",
                        color:
                          user.status === "Verified"
                            ? "#10B981"
                            : user.status === "Pending"
                              ? "#F59E0B"
                              : "#EF4444",
                      }}
                    >
                      {user.status === "Verified" && (
                        <>
                          <i
                            className="bx bxs-check-shield"
                            style={{ fontSize: "1rem" }}
                          ></i>
                          {/* Verified */}
                          {t('userProfile.status.verified')}
                        </>
                      )}
                      {user.status === "Pending" && (
                        <>
                          <i
                            className="bx bxs-hourglass-bottom"
                            style={{ fontSize: "1rem" }}
                          ></i>
                          {/* Pending */}
                          {t('userProfile.status.pending')}
                        </>
                      )}
                      {user.status === "Blocked" && (
                        <>
                          <i
                            className="bx bxs-error-alt"
                            style={{ fontSize: "1rem" }}
                          ></i>
                          {/* Blocked */}
                          {t('userProfile.status.blocked')}
                        </>
                      )}
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.4rem",
                      backgroundColor: "#FEF3C7",
                      borderRadius: "9999px",
                      padding: "4px 10px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#F59E0B" }}>
                      {user.rating ? user.rating.toFixed(1) : "0.0"}
                    </span>
                    <Star
                      size={18}
                      style={{ color: "#FBBF24", fill: "#FBBF24" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.4rem",
                      backgroundColor: "#F0F9FF",
                      borderRadius: "9999px",
                      padding: "4px 10px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <i
                      className="bx bxs-trophy"
                      style={{
                        fontSize: "15px",
                        color: "#0284C7",
                        marginBottom: "4px",
                      }}
                    ></i>
                    <div
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color: "#0284C7",
                      }}
                    >
                      {user.reward_points || 0}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#0284C7",
                        fontWeight: "600",
                      }}
                    >
                      {/* Reward Points */}
                      {t('userProfile.rewardPoints')}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* TAB NAVIGATION */}
          <div className="tab-nav">
            <Link
              to="/profile"
              style={tabItemStyle(
                location.pathname === "/profile" ||
                location.pathname === "/profile/"
              )}
            >
              {/* Profile */}
              {t('userProfile.tabs.profile')}
            </Link>

            {/* <Link
              to="/profile/changePassword"
              style={tabItemStyle(
                location.pathname.startsWith("/profile/changePassword")
              )}
            >
              {t('userProfile.tabs.password')}
            </Link> */}

            <Link
              to="/profile/rewards"
              style={tabItemStyle(location.pathname.startsWith("/profile/rewards"))}
            >
              {t("userProfile.tabs.rewards")}
            </Link>


            {/* **CHANGE HERE:** Replace Order History and Notifications tabs with Link components */}
            <Link
              to="/profile/orderhistory"
              style={tabItemStyle(
                location.pathname.startsWith("/profile/orderhistory")
              )}
            >
              {/* Order History */}
              {/* Orders */}
              {t('userProfile.tabs.orders')}

            </Link>
            <Link
              to="/profile/notifications"
              style={tabItemStyle(
                location.pathname.startsWith("/profile/notifications")
              )}
            >
              {/* Notifications */}
              {t('userProfile.tabs.notifications')}
            </Link>
          </div>

          {/* MAIN CONTENT AREA */}
          <div style={contentContainerStyle}>{renderContent()}</div>
          {/* <div className="content-container">{renderContent()}</div> */}
        </div>
      </div>

      {/* Edit Profile Form (Modal) */}
      {isEditFormVisible && (
        <EditProfileForm
          user={user}
          onClose={() => setEditFormVisible(false)}
          onProfileUpdate={handleProfileUpdate}
        />
      )}

      {/* Full-Screen Image Modal */}
      {isFullScreen && (
        <div className="full-screen-modal" onClick={() => setFullScreen(false)}>
          <img
            src={user && user.image ? `${URL}${user.image}` : userpic}
            alt="User"
            className="full-screen-image"
          />
          {user && user.image && (
            <button
              className="userprofile-delete-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirm(true);
              }}
            >
              {/* Delete Image */}
              <i className="fas fa-trash" style={{ marginRight: "5px" }}></i>
              {t('userProfile.deleteImage')}
            </button>
          )}
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {/* {showDeleteConfirm && (
        <div className="delete-confirm-modal">
          <div className="delete-confirm-content">
            <p>Are you sure you want to delete the image?</p>
            <button onClick={handleImageDelete}>Yes</button>
            <button onClick={() => setShowDeleteConfirm(false)}>No</button>
          </div>
        </div>
      )} */}

      {showDeleteConfirm && (
        <div className="userprofile-delete-confirm-modal">
          <div className="userprofile-delete-confirm-content">
            {/* <p>Are you sure you want to delete the image?</p>
            <button onClick={handleImageDelete}>Yes</button>
            <button onClick={() => setShowDeleteConfirm(false)}>No</button> */}
            <p>{t("userProfile.deleteConfirmMessage")}</p>
            <button className="userprofile-delete-confirm-button-yes" onClick={handleImageDelete}>{t("userProfile.yes")}</button>
            <button className="userprofile-delete-confirm-button-no" onClick={() => setShowDeleteConfirm(false)}>
              {t("userProfile.no")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UserProfile;

